import { Injectable } from '@angular/core';
import axios from 'axios';
import { from, lastValueFrom, Observable } from 'rxjs';
import { EmpresaVinculo } from '../../models/EmpresaVinculo';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { GrupoEmpresa } from '../../models/GrupoEmpresa';
import axiosClient from '../../../shared/axios/axios-client';
import { EmpresaResponse } from '../../models/Empresa';

@Injectable({
  providedIn: 'root',
})
export class EmpresasService {
  private apiUrl = environment.apiUrl;

  constructor(private authService: AuthService) {}

  async findAllEmpresas() {
    try {
      const response = await axiosClient.get('/empresa');
      return response.data;
    } catch (err) {
      console.error('Erro ao carregar empresas:', err);
    }
  }

  async findEmpresasSemGrupo() {
    try {
      const response = await axiosClient.get('/empresa/sem-grupo');
      return response.data;
    } catch (err) {
      console.error('Erro ao carregar empresas sem grupo:', err);
    }
  }

  buscarEmpresasVinculadasAoUsuario(): Observable<EmpresaVinculo[]> {
    const url = `${this.apiUrl}/empresa/vinculadas-usuario`;

    return from(axiosClient.get<EmpresaVinculo[]>(url).then((res) => res.data));
  }

  async buscarEmpresasComFlags(
    empresasSelecionadasOrIds?: EmpresaVinculo[] | number[],
    gruposBloqueados?: Set<number>,
    gruposValores?: Map<
      number,
      { buscaUsuarios: boolean; buscaPessoas: boolean }
    >
  ): Promise<EmpresaVinculo[]> {
    const empresas = await lastValueFrom(
      this.buscarEmpresasVinculadasAoUsuario()
    );

    return empresas.map((empresa) => {
      let buscaUsuarios = false;
      let buscaPessoas = false;

      if (empresasSelecionadasOrIds && empresasSelecionadasOrIds.length > 0) {
        if (typeof empresasSelecionadasOrIds[0] !== 'number') {
          const empresasSelecionadas =
            empresasSelecionadasOrIds as EmpresaVinculo[];
          const empresaSelecionada = empresasSelecionadas.find(
            (e) => e.idEmpresa === empresa.idEmpresa
          );
          if (empresaSelecionada) {
            buscaUsuarios = empresaSelecionada.buscaUsuarios;
            buscaPessoas = empresaSelecionada.buscaPessoas;
          } else if (
            empresa.idGrupo &&
            gruposBloqueados?.has(empresa.idGrupo) &&
            gruposValores
          ) {
            const grupoValores = gruposValores.get(empresa.idGrupo);
            if (grupoValores) {
              buscaUsuarios = grupoValores.buscaUsuarios;
              buscaPessoas = grupoValores.buscaPessoas;
            }
          }
        } else if (
          empresa.idGrupo &&
          gruposBloqueados?.has(empresa.idGrupo) &&
          gruposValores
        ) {
          const grupoValores = gruposValores.get(empresa.idGrupo);
          if (grupoValores) {
            buscaUsuarios = grupoValores.buscaUsuarios;
            buscaPessoas = grupoValores.buscaPessoas;
          }
        }
      } else if (
        empresa.idGrupo &&
        gruposBloqueados?.has(empresa.idGrupo) &&
        gruposValores
      ) {
        const grupoValores = gruposValores.get(empresa.idGrupo);
        if (grupoValores) {
          buscaUsuarios = grupoValores.buscaUsuarios;
          buscaPessoas = grupoValores.buscaPessoas;
        }
      }

      return {
        ...empresa,
        buscaUsuarios,
        buscaPessoas,
      };
    });
  }

  buscarGruposVinculadosAoUsuario(): Observable<GrupoEmpresa[]> {
    const url = `${this.apiUrl}/grupo/vinculados-usuario`;
    return from(axiosClient.get<GrupoEmpresa[]>(url).then((res) => res.data));
  }

  async consultaTelaVincularEmpresaAPessoa() {
    try {
      const response = await axiosClient.get(
        `${environment.apiUrl}/empresa/vincular-empresa`
      );

      return response.data;
    } catch (err) {
      console.error('Erro ao carregar empresas:', err);
    }
  }

  async buscarEmpresaPorId(id: number): Promise<EmpresaResponse> {
    if (!id || id === 0) {
      throw new Error('Dados da empresa inválidos');
    }

    try {
      const res = await axiosClient.get<EmpresaResponse>(`/empresa/${id}`);
      return res.data;
    } catch (err: any) {
      throw err;
    }
  }
}
